module.exports = __webpack_public_path__ + "static/media/Bennett_profile_transparent50.87a65547.png";